import { useEffect, useRef, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_1e8ff117-8550-4629-97e7-e6130082ef20/artifacts/lj0r9tzu_b_b_df_f_a_f_ca_a_emp_.mp4";

const links = [
  { label: "Home", href: "#home" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Who It's For", href: "#who-its-for" },
  { label: "Proof", href: "#proof" },
  { label: "FAQ", href: "#faq" },
  { label: "Apply", href: "#apply" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0D0E12]/85 border-b border-[#282930]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        <a
          href="#home"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <div className="w-9 h-9 overflow-hidden flex-shrink-0">
            <video
              ref={videoRef}
              src={LOGO_SRC}
              autoPlay
              muted
              loop
              playsInline
              className="logo-video w-full h-full object-cover"
            />
          </div>
          <span className="font-display text-[15px] tracking-wide text-[#F4EFE6]">
            Chadow<span className="text-[#C9A26B]"> </span>Marketing
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.slice(1, -1).map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-[12px] tracking-[0.18em] uppercase text-[#A8A39D] hover:text-[#F4EFE6] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#apply"
            data-testid="nav-apply-btn"
            className="hidden sm:inline-flex items-center text-[12px] tracking-[0.2em] uppercase px-6 py-3 bg-[#C9A26B] text-[#0D0E12] hover:bg-[#E5BE87] transition-colors duration-300"
          >
            Apply Now
          </a>
          <button
            type="button"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-[#F4EFE6] p-2"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-[#282930] bg-[#0D0E12]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-[13px] tracking-[0.2em] uppercase text-[#A8A39D] hover:text-[#F4EFE6] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
